import { SxProps } from "@mui/material";
import { LineChart, LineChartProps, XAxis, YAxis } from "@mui/x-charts";

type ChartProps = {
  xAxis: ReadonlyArray<XAxis> | undefined;
  yAxis: ReadonlyArray<YAxis> | undefined;
  series: LineChartProps["series"];
  sx?: SxProps;
};

export const PeriodLineChart = (props: ChartProps) => {
  return (
    <LineChart
      sx={props.sx}
      skipAnimation
      xAxis={props.xAxis}
      yAxis={props.yAxis}
      series={props.series}
      height={300}
      hideLegend={true}
    />
  );
};
